export const programId = '5ec6cb4f7260861b173c224a';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
